<template>
    <div>
        <div>
            <div v-if="region.name === 'Centro-Oeste'">
                <p>
                    <strong>Inspiração</strong> e <strong>criatividade</strong> não são coisas que
                    surgem do nada. Mesmo que, às vezes, a ideia só apareça, toda ideia vem de algum
                    lugar e se forma a partir do emaranhado de coisas que nos rodeiam. Podem ser
                    histórias e lugares reais ou não, tudo cabe no universo criativo. Mas o que
                    fazer quando um lugar de verdade até parece mentira de tão bonito que é? Em
                    terra de sonhador, o <strong>Alto Paraíso de Goias</strong> é como viver sem ter
                    que acordar e, para aqueles que se aventuram nas selvas de pedra, o Distrito
                    Federal é inspiração certeira para boas histórias. A
                    <strong> cidade com formato de avião</strong> faz com que a gente se sinta nas
                    alturas ao olhar pro céu, é que o céu de <strong>Brasília</strong> é tão lindo
                    que inspira canções e você sente que quase pode tocar as estrelas sem sair do
                    chão. Nesse voo bonito de se ver a gente percebe que a beleza mora em cada
                    esquina da nossa <strong> capital</strong>. Essas coleções são feitas a partir
                    da inspiração dos <strong>nossos artistas</strong> e a
                    <strong>Chico</strong> carrega estampas que viajam o mundo para chegar até você!
                </p>
            </div>
            <div v-if="region.name === 'Nordeste'">
                <p>
                    A arte se manifesta na palavra escrita e também na cantada, ela está presente na
                    cozinha, no cultivo e no reconhecimento de valor da sua própria história. A arte
                    vai muito além da obra porque é o sentimento partilhado que forma esse todo que
                    chamamos de expressão. No <strong>Nordeste</strong> a arte transborda, escorre
                    pelas beiradas e cria vida por onde passa. Por isso, aqui na
                    <strong>Chico Rei</strong>, a gente criou uma seleção especial dedicada a
                    estampas que exaltam a
                    <strong>cultura nordestina</strong>
                </p>
            </div>
            <div v-if="region.name === 'Norte'">
                <p>
                    A gente tem muito a aprender quando decide olhar para a história. No Brasil, o
                    berço da diversidade, temos culturas, histórias e crenças que, de
                    <strong>Norte</strong> a Sul, tem seus próprios jeitos de existir. E por falar
                    na região Norte, o folclore, o carimbó e as <strong>cirandas</strong> falam de
                    arte, cultura e poesia de um povo rico que carrega muita beleza nas veias. Por
                    aqui, a gente criou uma seleção especial pra estampar e exaltar essas histórias
                    nas nossas <strong>camisetas</strong>, <strong>bandeiras</strong> e
                    <strong>canecas</strong>.
                </p>
            </div>
            <div v-if="region.name === 'Sudeste'">
                <p>
                    Passa um cafezinho e vem cá pra ver a linda coleção que conta as
                    <strong> histórias</strong> que acontecem por essas bandas. Na
                    <strong>região Sudeste</strong> cê encontra todo tipo de beleza e muita
                    <strong>cultura</strong> diferente, entre os uais, as falas cantadas e os
                    sotaques que puxam o X ou o R, a gente percebe que bonito mesmo é ver o jeitinho
                    de ser de cada um. Essas diferenças são encantadoras demais da conta e nós
                    fazemos questão de exaltar todas elas nas nossas
                    <strong>estampas</strong>
                </p>
            </div>
            <div v-if="region.name === 'Sul'">
                <p>
                    O <strong>Sul</strong> é um amontoado bonito demais de influências. Talvez seja
                    por isso que a<strong>cultura</strong> gaúcha transborda poesia e arte. Seja na
                    dança, na literatura ou na culinária, fica claro que todas essas influências só
                    deixaram o <strong>Sul</strong> ainda mais encantador. Do lado de cá, a gente
                    criou uma seleção pra lá de especial para estampar toda essa poesia.
                </p>
            </div>
        </div>
        <div v-for="partner in partners">
            <div class="d-flex flex-align-center mt-4 mb-3">
                <h4 class="my-0">{{ partner.name }}</h4>
                <a
                    :href="`${partner.type_id === 2 ? '/artistas' : ''}/${partner.url}`"
                    class="flex-child-fixed d-flex flex-align-center text-uppercase text-primary text-yanone ml-auto"
                >
                    Ver todos
                    <i class="icon-cr icon-chevron-right" />
                </a>
            </div>
            <ProductGroupList
                :limit="4"
                :products="partner.products"
                class="product-horizontal-list product-horizontal-list-4 mt-2"
            />
        </div>
    </div>
</template>

<script>
    import ProductGroupList from '../product/ProductGroupList';

    export default {
        name: 'CountryRegionPartners',

        components: { ProductGroupList },

        props: {
            region: {
                type: Object,
                required: true,
            },
        },

        computed: {
            partners() {
                return this.region.partners.data.filter((p) => p.products.length === 4);
            },
        },
    };
</script>
